<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
};
</script>
<style lang="scss">
body,
div,
ul,
li,
ol,
h1,
h2,
h3,
h4,
h5,
h6,
input,
textarea,
select,
p,
dl,
dt,
dd,
a,
img,
button,
form,
table,
th,
tr,
td,
tbody,
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  margin: 0;
  padding: 0;
}

html {
  font-size: 62.5%; /* 根元素是10px;     16*62.5%=10  默认在pc端根元素会解析成12px    */
  // overflow-y: overlay;
}

body {
  font-family: "SourceHanSansSC", "SourceHanSansSC";
  font-size: 12px;
  line-height: 1.5;
  color: #555;
  background-color: #fff;
}

em,
i {
  font-style: normal;
}

ul,
li {
  list-style-type: none;
}

strong {
  font-weight: normal;
}
</style>
